import * as React from 'react';
import { Toaster, toaster } from 'components/ui/toaster';
import { useEffect } from 'react';
import { useAppSelector } from '../../store/hooks';
import { selectNotifications } from '../../store/notificationSlice';

export default function Notification() {
  const notifications = useAppSelector(selectNotifications);
  useEffect(() => {
    notifications
      .filter((notification) => !toaster.isVisible(notification.id))
      .map((notification) =>
        toaster.create({
          id: notification.id,
          title: notification.title,
          description: notification.description,
          type: notification.type,
          duration: notification.duration ?? undefined,
          closable: notification.isClosable,
        }),
      );
  }, [notifications]);

  return <Toaster />;
}
